<template>
  <svg
    id="Elaboração"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height ? height : width"
    viewBox="0 0 237.063 205.194"
  >
    <g
      id="Retângulo_13"
      data-name="Retângulo 13"
      transform="translate(0 29.194)"
      fill="none"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="15"
    >
      <rect width="182" height="176" rx="35" stroke="none" />
      <rect x="7.5" y="7.5" width="167" height="161" rx="27.5" fill="none" />
    </g>
    <rect
      id="Retângulo_14"
      data-name="Retângulo 14"
      width="51"
      height="118"
      transform="translate(140 11.194)"
      fill="#fff"
    />
    <path
      id="Icon_awesome-pencil-alt"
      data-name="Icon awesome-pencil-alt"
      d="M163.665,48.805l-15.154,15.84a3.829,3.829,0,0,1-5.588,0l-36.488-38.14a4.26,4.26,0,0,1,0-5.841l15.154-15.84a15.332,15.332,0,0,1,22.32,0l19.756,20.65A17,17,0,0,1,163.665,48.805ZM93.417,34.271,7.094,124.5.125,166.248c-.953,5.635,3.747,10.514,9.138,9.552l39.94-7.319,86.323-90.229a4.26,4.26,0,0,0,0-5.841L99.038,34.271a3.867,3.867,0,0,0-5.621,0Zm-52.628,82.5a4.945,4.945,0,0,1,0-6.8L91.412,57.051a4.445,4.445,0,0,1,6.509,0,4.945,4.945,0,0,1,0,6.8L47.3,116.769a4.445,4.445,0,0,1-6.509,0Zm-11.867,28.9H44.7v12.473l-21.2,3.883L13.274,151.335l3.715-22.162H28.921Z"
      transform="translate(68.788 -0.005) rotate(1)"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { required: false, type: String, default: '100%' },
    height: { required: false, type: String },
    color: { required: false, type: String, default: '#4e73df' }
  }
}
</script>
